var render, staticRenderFns
import script from "./sip-select.vue?vue&type=script&lang=js"
export * from "./sip-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f23a5a')) {
      api.createRecord('38f23a5a', component.options)
    } else {
      api.reload('38f23a5a', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/sip-select.vue"
export default component.exports